import { Component, OnInit, Input, ViewChild, ApplicationRef, OnDestroy } from '@angular/core';
import { ContactInfo } from 'projects/app-misc/src/app/modules/customer/data/contactInfo';
import { NgForm } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { CustomerService } from 'projects/app-misc/src/app/modules/customer/data/customer.service';
import { CustomerWindowStore } from 'projects/app-misc/src/app/modules/customer/data/customer-window.store';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RxJSUnsubscribe } from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import { RxJSUnsubscribable } from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';

@Component({
    selector: 'app-contact-info',
    templateUrl: './contact-info.component.html',
    styleUrls: ['./contact-info.component.scss']
})
@RxJSUnsubscribe
export class ContactInfoComponent implements OnInit, OnDestroy, RxJSUnsubscribable {
    @Input()
    contact: ContactInfo;

    expansionHeader: string;

    @ViewChild('editContactForm', { static: true })
    editCustomerForm: NgForm;

    protected phoneChanges$ = new Subject<string>();

    saveSubj: Subscription

    constructor(
        private customerService: CustomerService,
        private appRef: ApplicationRef,
        protected customerWindowStore: CustomerWindowStore

    ) { }

    ngOnInit() {
        this.editCustomerForm.valueChanges
            .pipe(
                takeUntil(this.getUnsubFromAllSubs()),
                debounceTime(1000),
                distinctUntilChanged()
            ).subscribe(value => {
                this.saveContact()
            })

        this.updateContactHeader()

        this.phoneChanges$.pipe(
            debounceTime(1000)
        ).subscribe(emit => {
            this.saveContact();
        })
    }

    telephoneChanged() {
        this.phoneChanges$.next(this.contact.phone1);
    }

    saveContact() {
        this.customerService.saveContact(this.contact).subscribe()
        this.updateContactHeader()
    }

    updateContactHeader() {
        this.customerWindowStore.updateHeaderTitle(this.contact.id, this.expansionHeader);
    }

    getUnsubFromAllSubs(): Subject<boolean> {
        return null
    }

    ngOnDestroy() {
        // 		this.saveSubj.unsubscribe()
    }
}
